import { render } from "./SetupPassword.vue?vue&type=template&id=05925fce&scoped=true"
import script from "./SetupPassword.vue?vue&type=script&lang=js"
export * from "./SetupPassword.vue?vue&type=script&lang=js"

import "./SetupPassword.vue?vue&type=style&index=0&id=05925fce&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05925fce"]])

export default __exports__